/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Voice_SelectInputs */

const en_settings_voice_select = /** @type {(inputs: Settings_Voice_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select`)
};

const es_settings_voice_select = /** @type {(inputs: Settings_Voice_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar`)
};

/**
* | output |
* | --- |
* | "Select" |
*
* @param {Settings_Voice_SelectInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_voice_select = /** @type {((inputs?: Settings_Voice_SelectInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Voice_SelectInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_voice_select(inputs)
	return en_settings_voice_select(inputs)
});